<template>
  <div
      class="relative w-full h-[38rem] z-10 -my-20 flex flex-col items-center justify-center md:max-w-[960px] text-center overflow-hidden"
      :style="cssVars"
  >
    <div class="h-full w-full">
      <div
          class="w-full h-[40rem] z-1 absolute bg-linear-135 from-[var(--light-variant-1)]/25 to-[var(--primary-color)]/45"></div>
      <div class="absolute top-50 left-30 z-2 ">
        <div class="flex flex-col items-start">
          <component :is="titleTag" class="doc-title text-4xl font-bold text-[var(--dark-variant-2)]">{{ title }}</component>
          <span class="text-2xl text-left mt-4 text-[var(--dark-variant-2)]">{{ subtitle }}</span>
        </div>
      </div>
      <div v-if="backgroundImage"
          class="absolute z-0 right-4 top-20 w-[30rem] h-[30rem] rounded-full overflow-hidden flex items-center justify-center">
        <img
            :src="resolveMediaUrl(backgroundImage)" v-bind="imgAttrs(resolveMediaUrl(backgroundImage), '480px')"
            class="w-[30rem] h-[30rem]  object-cover opacity-20"
            alt=""
        />
      </div>
    </div>
    <div class="w-full absolute mt-80">
      <div class="w-full border-2 border-[var(--primary-color)] "></div>
      <div class="w-full border-3 border-[var(--dark-variant-2)] "></div>
    </div>


  </div>
</template>
<script setup>
import {imgAttrs} from "@/utils/photoSizes.js";
import {computed} from "vue";
import {useSectionHeadingTag} from "@/composables/useSectionHeadingTag.js";
import {resolveMediaUrl} from "@/composables/images.js";
// The title is a span; on a page with no hero it is the H1 and draws the same.
const titleTag = useSectionHeadingTag("span");

const props = defineProps({
  title: {type: String, required: true},
  subtitle: {type: String, required: true},
  backgroundImage: {type: String, default: ""},
  colors: {type: Object, required: true}
});

const cssVars = computed(() => ({
  "--light-variant-1": "var(--brand-whitest)",
  "--light-variant-2": "var(--brand-lightest)",
  "--light-variant-3": "var(--brand-light)",
  "--dark-variant-1": "var(--brand-dark)",
  "--dark-variant-2": "var(--brand-darkest)",
  "--primary-color": "var(--brand-primary)",
  "--accent-color": "var(--brand-accent)",
  "--link-color": "var(--brand-accent)",
  "--link-hover-color": "var(--brand-accent-dark)"
}));
</script>

<style scoped>
/* As an h1, the new themes' heading font, weight, tracking and case (theme.css) and nightwatch's display font would
   otherwise apply; the span never took them. */
.doc-title { font-family: inherit; font-weight: 700; letter-spacing: inherit; text-transform: inherit; }
</style>
